import React from 'react'
import './searchBarHL.css'
import { searchIcon } from '../../../assets/logos/icons'
import TooltipHLPure from '../../pures/tooltipHL/tooltipHL.pure'

const SearchBarHLPure = (props) => {
  const {
    placeholder,
    onSearchChange,
    searchValue,
    icon,
    tooltip,
    fullWidth,
  } = props

  const handleClear = () => {
    const clearInput = { target: { value: '' } }
    onSearchChange(clearInput)
  };

  const clearIcon = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_CLEAR_BUTTON_ICON}`

  return (
    <div className={`searchBarHL-container${fullWidth ? ' searchBarHL-fullWidth' : ''}`}>
      <div className='searchBarHL-containerInput'>
        {tooltip && (
          <div className='searchBarHL-containerTooltip'>
            <TooltipHLPure {...props} />
          </div>
        )}
        <label htmlFor='search' className='searchBarHL-icon' aria-label={placeholder}>
          <img src={icon || searchIcon} className='searchBarHL-iconSearchStyle' alt='Buscar' />
        </label>
        <input
          {...props}
          type='text'
          id='search'
          name='search'
          className='searchBarHL-input'
          value={searchValue}
          placeholder={placeholder}
          onChange={onSearchChange}
        />
        {searchValue && (
          <button
            type='button'
            className='searchBarHL-clearButton'
            onClick={handleClear}
            aria-label='Limpiar búsqueda'
          >
            <img
              src={clearIcon}
              alt='Limpiar'
              className='searchBarHL-clearIcon'
            />
          </button>
        )}
      </div>
    </div>
  );
};

export { SearchBarHLPure as default }
